import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormInput } from "../../components/FormInput";
import { F2020102Before } from "../../utility/service/personal-service";
import { checkDpSuccess } from "../../utility/service/tool-service";
import { addFormValidator } from "../../utility/validate/formValidator";
import { TreeSelect } from "primereact/treeselect";
import { Controller, useForm } from "react-hook-form";

const AddRole = ({ register, errors, control, treeOptions, setValue, approveFlag }) => {
  const { t } = useTranslation();
  const [formRule, setFormRule] = useState([]); //表單驗證

  //建立前查詢form 規則
  const axios_getCreateBefore = () => {
    F2020102Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule],
  );

  useEffect(() => {
    axios_getCreateBefore();
  }, []);

  return (
    <div className="grid">
      {approveFlag && (
        <div className="col-12">
          <label className="form-label">{t("parentNode")}</label>
          <Controller
            name="parentId"
            control={control}
            render={({ field, fieldState }) => (
              <>
                <TreeSelect
                  showClear
                  value={field.value}
                  options={treeOptions}
                  onChange={(e) => {
                    field.onChange(e.value);
                    if (e.value === null || e.value === "" || e.value === undefined) {
                      setValue("parentId", "");
                    }
                  }}
                  className={`w-full ${fieldState.invalid ? "p-invalid" : ""}`}
                  placeholder={t("plz_chs")}
                />
                {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
              </>
            )}
          />
        </div>
      )}
      <div className="col-12">
        <FormInput
          register={register}
          errors={errors}
          id="symbol"
          type="text"
          labelText={t("role_symbol")}
          labelClass="control-label required"
          rules={setValidForm("symbol")}
        />
      </div>
      <div className="col-12">
        <FormInput
          register={register}
          errors={errors}
          id="name"
          type="text"
          labelText={t("role_name")}
          labelClass="control-label required"
          rules={setValidForm("name")}
        />
      </div>
    </div>
  );
};

export default AddRole;
